import { Guid, Nillable } from '@web/utils';
import { BoxQuestionnaireSelectType, BoxQuestionnaireStatus, OrderNumber } from '@web/shared/module/shop';
import { AdminBoxQuestionnaireContextOperations } from './admin-box-questionnaire-context-operations';

export class AdminBoxQuestionnaireCollectionItem {
  public constructor(
    private readonly data: {
      contextOperations: AdminBoxQuestionnaireContextOperations;
      createdAt: Date;
      endDate: Date;
      id: Guid;
      isShown: boolean;
      hasError: boolean;
      errorMessage?: Nillable<string>;
      logoAlt?: Nillable<string>;
      logoUrl?: Nillable<string>;
      name: string;
      orderId: Guid;
      orderNumber: OrderNumber;
      ownerName: string;
      status: BoxQuestionnaireStatus;
      selectTypes: BoxQuestionnaireSelectType[];
    },
  ) {}

  public get contextOperations(): AdminBoxQuestionnaireContextOperations {
    return this.data.contextOperations;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get endDate(): Date {
    return this.data.endDate;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get isShown(): boolean {
    return this.data.isShown;
  }

  public get hasError(): boolean {
    return this.data.hasError;
  }

  public get errorMessage(): Nillable<string> {
    return this.data.errorMessage;
  }

  public get logoAlt(): Nillable<string> {
    return this.data.logoAlt;
  }

  public get logoUrl(): Nillable<string> {
    return this.data.logoUrl;
  }

  public get name(): string {
    return this.data.name;
  }

  public get orderId(): Guid {
    return this.data.orderId;
  }

  public get orderNumber(): OrderNumber {
    return this.data.orderNumber;
  }

  public get ownerName(): string {
    return this.data.ownerName;
  }

  public get status(): BoxQuestionnaireStatus {
    return this.data.status;
  }

  public get selectTypes(): BoxQuestionnaireSelectType[] {
    return this.data.selectTypes;
  }

  public get canBeViewed(): boolean {
    return this.contextOperations.canBeViewed;
  }

  public get canBeResumed(): boolean {
    return this.contextOperations.canBeResumed;
  }

  public get canBeEnded(): boolean {
    return this.contextOperations.canBeEnded;
  }

  public get canBeSelectionChanged(): boolean {
    return this.contextOperations.canBeSelectionChanged;
  }
}
